
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { VrProvider } from './vr/VrContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <VrProvider>
      <App />
    </VrProvider>
  </React.StrictMode>
);
